import { useCallSikSearch } from "@coworker/apprestructured/src/scan-and-search/hooks/search/useCallSikSearch";
import { parseSIKItem } from "@coworker/apprestructured/src/scan-and-search/utils/parseSikSearchResult";
import {
  MainItemType,
  SikSearchMoreResponseType,
  SikSearchResponseType,
} from "@coworker/apprestructured/src/scan-and-search/types/SikSearchResponseType";
import { useCallSikSearchCoworker } from "./useCallSikSearchCoworker";
import useFlag from "@coworker/app/src/hooks/useFlag";
import { FLAGS } from "@coworker/enums/featureFlags";

export const useTransformSikSearch = (
  searchQuery: string,
  shouldHideSPRItems: boolean = false,
  shouldSkipSikSearch: boolean = false
) => {
  const useNewProductSearch = useFlag(FLAGS.ENABLE_NEW_PRODUCT_SEARCH);
  const useSearch = useNewProductSearch
    ? useCallSikSearchCoworker
    : useCallSikSearch;

  const {
    data: sikResponse,
    isLoading,
    isError,
    fetchNextPage,
  } = useSearch(searchQuery, shouldSkipSikSearch);

  let allItems;
  let totalItems: number = 0;

  const filterSPRItems = (item: MainItemType) =>
    shouldHideSPRItems ? item.product.itemType !== "SPR" : true;

  if (!isLoading && !isError && sikResponse) {
    const firstPageItems =
      (sikResponse?.pages[0] as SikSearchResponseType)?.searchResultPage
        ?.products?.main?.items || [];

    totalItems = (sikResponse?.pages[0] as SikSearchResponseType)
      ?.searchResultPage?.products?.badge;

    const otherPageItems = sikResponse?.pages
      .slice(1)
      .flatMap((page) => (page as SikSearchMoreResponseType)?.more?.items);

    allItems = firstPageItems
      .concat(otherPageItems || [])
      .filter(filterSPRItems)
      .map((item) => parseSIKItem(item?.product));
  }
  return {
    isError,
    isLoading,
    data: { items: allItems, totalItems: totalItems },
    fetchNextPage,
  };
};
